<template>
  <div class="sign" :class="{'first': nextStep === false}">
    <!--<h1>Forgot Password</h1>
    <div v-if="nextStep">
      <div class="input-item">
        <el-input type="password" maxlength="16" v-model="psd" placeholder="New Password" @input="validate('psd')" />
        <div class="line" :class="{'warn': psdWarn}"></div>
      </div>
      <div class="input-item" style="margin-bottom:40px">
        <el-input type="password" maxlength="16" v-model="repsd" placeholder="Confirm Password" @input="validate('repsd')" />
        <div class="line" :class="{'warn': repsdWarn}"></div>
      </div>
    </div>
    <div v-if="!nextStep">
      <div class="input-item"> 
        <el-input type="text" maxlength="20" v-model="mobile" placeholder="Username" @input="validate('mobile')" />
        <div class="line" :class="{'warn': mobileWarn}"></div>
      </div>
      <div class="input-item" style="margin-bottom:40px">
        <el-input type="text" maxlength="10" v-model="code" placeholder="Verification code" @input="validate('code')" />
        <div class="line" :class="{'warn': codeWarn}"></div>
        <div class="sent" v-if="!waiting" @click="send">Send</div>
        <div class="sent" v-if="waiting">{{num}} s</div>
      </div>
    </div>
    <button class="light" @click="confirm" v-if="nextStep">Confirm</button>
    <button class="light" @click="next" v-if="!nextStep">Next</button>
    <button class="dark" @click="back">Back</button>
  </div>-->
  <h1>Forgot Password</h1>
    <div v-if="nextStep">
      <div class="input-item">
        <el-input type="text" maxlength="10" v-model="code" placeholder="Verification code" @input="validate('code')" />
        <div class="line" :class="{'warn': codeWarn}"></div>
      </div>
      <div class="input-item" style="margin-bottom:40px">
        <el-input type="password" autoComplete="new-password" maxlength="16" v-model="psd" placeholder="New Password" @input="validate('psd')" />
        <div class="line" :class="{'warn': psdWarn}"></div>
      </div>
    </div>
    <div v-if="!nextStep">
      <div class="input-item"> 
        <el-input type="text" maxlength="30" v-model="mobile" placeholder="Username" @input="validate('mobile')" />
        <div class="line" :class="{'warn': mobileWarn}"></div>
      </div>
    </div>
    <button class="light" @click="confirm" v-if="nextStep">Confirm</button>
    <button class="light" @click="send" v-if="!nextStep">Next</button>
    <button class="dark" @click="back">Back</button>
  </div>
</template>

<script>
import api from '../../api/login'
export default {
  name: 'login',
  data () {
    return {
      mobile: '',
      mobileWarn: false,
      code: '',
      codeWarn: false,
      psd: '',
      psdWarn: false,
      repsd: '',
      repsdWarn: false,
      code: '', // 验证码
      waiting: false, // 是否正在等待倒计时
      num: null, // 当前剩余倒计秒数
      timer: null, // 定时器清除用
      nextStep: false// 是否已到了下一步
    }
  },
  created () {
    var that = this
    /*if (localStorage.getItem('time')) {
      let timestamp = (new Date()).getTime()
      let prevTime = JSON.parse(localStorage.getItem('time'))
      let _count = parseInt((timestamp - prevTime) / 1000)
      if (_count < 60) {
        that.num = 60 - _count
        that.waiting = true
        that.timer = setInterval(that.count, 1000)
      }
    }*/
  },
  methods: {
    validate (txt) {
      var that = this
      if (txt == 'mobile') {
        //that.mobile = that.mobile.replace(/[^\d]/g,'')
        if (that.mobile.length > 0) {
          that.mobileWarn = false
        }
      } else if (txt == 'code') {
        that.code = that.code.replace(/[^\d]/g,'')
        if (that.code.length > 0) {
          that.codeWarn = false
        }
      } else if (txt == 'psd') {
        if (that.psd.length > 0) {
          that.psdWarn = false
        }
      } else if (txt == 'repsd') {
        if (that.repsd.length > 0) {
          that.repsdWarn = false
        }
      }
    },
    back () {
      if (this.nextStep === false) {
        this.$router.replace('/login')
        clearInterval(this.timer)
          this.waiting = false
          localStorage.removeItem('time')
      } else if (this.nextStep === true) {
        this.nextStep = false
        this.code = null
      }
    },
    send () {
      var that = this
      // 先判断有没有输入手机号
      // that.mobile = that.mobile.replace(/[^\d]/g,'')
      if (that.mobile == '') {
        that.mobileWarn = true
        return
      }
      // 调接口
      api.note({
        params: {
          userName: that.mobile
        },
        callback: that.sendCallback
      })
      // 倒数操作
      /*that.waiting = true
      let timestamp = (new Date()).getTime()
      that.num = 60
      localStorage.setItem('time', timestamp)
      that.timer = setInterval(that.count, 1000)*/
    },
    count () {
      if (this.num > 0) {
        this.num --
      } else {
        clearInterval(this.timer)
        this.waiting = false
        localStorage.removeItem('time')
      }
    },
    next () {
      var that = this
      if (that.mobile.replace(/\s+/g,'') == '') {
        that.mobileWarn = true
      }
      if (that.code.replace(/\s+/g,'') == '') {
        that.codeWarn = true
      }
      if (that.mobile.replace(/\s+/g,'') == '' || that.code.replace(/\s+/g,'') == '') {
        return
      }
      // 在这里调接口，判断验证码是否正确
      api.check({
        params: {
          code: that.code,
          phone: that.mobile
        },
        callback: that.nextCallback
      })
    },
    nextCallback(res) {
      if (res.data.code == 0) {
        this.nextStep = true
      } else {
        Utils.alert('', res.data.message ,'error')
      }
    },
    confirm () {
      var that = this
      if (that.psd.replace(/\s+/g,'') == '') {
        that.psdWarn = true
      }
      if (that.code.replace(/\s+/g,'') == '') {
        that.codeWarn = true
      }
      if (that.psd.replace(/\s+/g,'') == '' || that.code.replace(/\s+/g,'') == '') {
        return
      }
      // 在这里调接口修改密码
      api.alPassword({
        params: {
          code: that.code,
          password: that.psd,
          userName: that.mobile
        },
        callback: that.confirmCallback
      })
    },
    // 发送短信接口回调
    sendCallback (res) {
      if (res.data.code == 0) {
        this.nextStep = true
      } else {
        Utils.alert('', res.data.message ,'error')
        clearInterval(this.timer)
        this.waiting = false
        //localStorage.removeItem('time')
      }
    },
    confirmCallback (res) {
      if (res.data.code == 0) {
        this.$router.replace('/login')
      } else {
        Utils.alert('', res.data.message ,'error')
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.sign{
  width: 410px;
  height: 465px;
  background: var(--background-color-4);
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -232px 0 0 -205px;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 50px 50px 0 50px;
  h1{
    font-size: 30px;
    text-align:center;
    margin-bottom: 60px;
    color: var(--text-color);
    span{
      transition: all .5s;
      top: -30px;
      position: relative;
      opacity: 0;
    }
  }
  .input-item{
    margin-bottom: 35px;
    position: relative;
    .line{
      width: 0;
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      border-bottom: 1px solid #EA3796;
      overflow: hidden;
      transition: all .3s;
    }
    .warn{
      width: 100%;
    }
    .sent{
      position: absolute;
      right: 0;
      top: 0;
      line-height: 36px;
      font-size: 16px;
      color: #EA3796;
      cursor: pointer;
    }
  }
  p{
    font-size: 12px;
    text-align:right;
    color: var(--text-color);
    margin-bottom: 40px;
    span{
      cursor: pointer;
    }
  }
  .light{
    display: block;
    outline: none;
    background: none;
    cursor: pointer;
    width: 310px;
    height: 50px;
    border: 2px solid #EA3796;
    color: #EA3796;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .dark{
    display: block;
    outline: none;
    background: none;
    cursor: pointer;
    width: 310px;
    height: 50px;
    border: 2px solid var(--text-color);
    color: var(--text-color);
    font-size: 20px;
  }
}
.first{
  height: 425px;
  margin-top: -212px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/forget.vue